export const localeMessage = {
  en: {
    remove: `Remove`,
    categoryCannotBeEmpty: `Category cannot be empty`,
    toBatchEditingOfMainProducts: `How to "Batch Editing of Master Products"\uFF1F`,
    toPublishToTheStoreHow: `How to "Publish to the store"\uFF1F`,
    previous: `Previous`,
    percentageLimit: `The percentage range should be 0-100,000`,
    purchasePriceLimit: `Price Should be between 0-1,000,000,000!`,
    WorkingDaysBetween: `Between 7-90 working days`,
    beBetweenWorkingHoursMust: `Must be between 1-8 working hours`,
    updatedSuccessfully: `Updated Successfully`,
    orderProcessingTimeFollowsTheShops: `The order processing time follows the shop\u2019s settings`,
    categoryLazada: `Lazada category`,
    categoryBukalapak: `Bukalapak category`,
    categoryTokopedia: `Tokopedia category`,
    categoryShopee: `Shopee category`,
    ProductDescriptionShort: `Short description`,
    publishTo: `Publish to`,
    viewDtails: `view details`,
    toViewTheMassOperationRecords1: `Supported to view the mass operation records of the past 7 days`,
    selectedMasterProductHasBeenCopied: `The selected Master Product has been copied to the draft in the target store, please edit and complete the information according to the channel requirements before publishing to the store`,
    productName: `Product Name`,
    productNameLimit: `Product Name must be between 5 - 300 character`,
    variationImageSizeLimit: `Multiple images can be uploaded at once .  At least 300 x 300 pix,up to 5MB\uFF08up to 8photos)`,
    customDisplayInformation: `Custom display information`,
    mass: `Mass`,
    add: `Add`,
    editProductImage: `Edit Product Image:`,
    massEditProductName: `Mass Edit Product name`,
    massEditDimensionsCm: `Mass Edit dimensions (cm)`,
    max: `Max. 999,999`,
    max7: `Max. 500,000`,
    massEditWeightG: `Mass Edit weight (g)`,
    massEditMinPurchaseQuantity: `Mass Edit Min. purchase quantity`,
    changeMinPurchaseQuantityTo: `Change Min. purchase quantity to`,
    max11: `Max. 1000`,
    minPurchaseQuantityShouldBe: `Min. purchase quantity should be 1-1000`,
    massEditAvailableStock: `Mass Edit available stock`,
    theInventoryOfTheMasterProduct: `The inventory of the Master Product is managed in [Inventory Management], please go there to edit Warehouse Stock of the selected Product\uFF08Available Stock = Warehouse Stock-Spare Stock-Locked Stock-Promotion Stock\uFF09`,
    goToEdit: `Go to Edit`,
    condition: `Condition`,
    massEditCondition: `Mass Edit Condition`,
    chooseACountry: `Choose a Country/Region`,
    nextStep: `Next step`,
    saveUpdateAndNextStep: `Save and next step`,
    partOfTheMasterProductIs: `As requirements of the channel store to publish products, some fields in Master Product must be filled. Please fill the required fields before publish it to the store.`,
    publishToTheStore: `Publish to the store`,
    massEdit: `Mass edit`,
    productNameInThisStoreIs: `Product Name in this Store is already used`,
    reasonForFailure: `missing required information, please complete the information`,
    lazadaCategoryAttribute: `Lazada category attribute`,
    bukalapakCategoryAttribute: `Bukalapak category attribute`,
    tokopediaCategoryAttribute: `Tokopedia category attribute`,
    shopeeCategoryAttribute: `Shopee category attribute`,
    blibliCategoryAttribute: `Blibli category attribute`,
    category: `Category`,
    shippingSettings: `Shipping Settings`,
    massEditProductDescription: `Mass Edit Product description`,
    iNeed: `I need`,
    workingHours: `Working hours`,
    applyToAllProducts: `Apply to all Products`,
    theValueJustEnteredWantIt: `The value just entered, want it applied to all the products of the same category?`,
    masterProductVariantType2: `Match the variant type of the Master product to the target store`,
    masterProductVariantType: `Master Product Variant type`,
    matchVariantType: `Match  Variant type`,
    matchTokopediaVariantType: `Match Tokopedia Variant type`,
    massEditOfShopeesCategoryAttribute: `Mass Edit of Shopee's category attribute`,
    publishingToChannelStores: `Publishing to channel stores`,
    productsWereSuccessfullyPublished: `29 Products were successfully published`,
    allPublished: `All published`,
    somePublishFailed: `Some publish failed`,
    allPublishFailed: `All publish failed`,
    taskType: `Task type`,
    search: `Search`,
    creator: `Creator`,
    content: `Content`,
    publishedStoreStoreStore: `Published Store: Store 1, store 2`,
    taskStatus: `Task status`,
    publishing: `Publishing`,
    successfulQtyAllQty: `Successful Qty / All Qty`,
    massOperationHistory: `Mass operation history`,
    theResultOfThePublishWill: `The result of the publish will be synchronized in [Master Products - Mass Operation History]`,
    theFileWillOnlyBeReserved: `The file will only be reserved for 7 days, please check or download in time`,
    no: `No`,
    yes: `Yes`,
    orderProcessingDeadline: `Order Processing Deadline`,
    instant: `Instant`,
    regular: `Regular`,
    preorder: `Preorder`,
    iWillShipOutWithinX: `I will ship out within x working hours.`,
    hoursWorking: `working hours`,
    mustBeBetween: `Must be between 1-8`,
    iWillShipOutWithin: `I will ship out within 3 working days. (excluding public holidays and courier service non-working days)`,
    workingDays: `working days`,
    between: `Between 3-30`,
    preorder11: `Preorder`,
    iNeedXDaysToShip: `I need X days to ship`,
    INeed: `I need`,
    toShip: `to ship`,
    iNeedXWeeksToShip: `I need X weeks to ship`,
    iNeedXWorkingDays: `I need X working days to ship`,
    shipTime: `Process Time`,
    enterProcessTime: `Enter Process Time`,
    betweenDays: `Between 1-90 days`,
    day: `day`,
    betweenWeeks: `Between 1-13 weeks`,
    week: `week`,
    between21: `Between 7-15`,
    iWillShipOutWithin22: `I will ship out within 2 working days. (excluding public holidays and courier service non-working days)`,
    lengthShouldBeBetween: `Length Should be between 1-999,999!`,
    widthShouldBeBetween: `Width Should be between 1-999,999!`,
    heightShouldBeBetween: `Height Should be between 1-999,999!`,
    weightShouldBeBetween: `Weight Should be between 1-5000,000!`,
    editProductName: `Edit Product Name`,
    addBeforeName: `Add before name`,
    addAfterName: `Add after name`,
    addBetweenName: `Add between name`,
    replaceWith: `Replace with`,
    confirm: `Confirm`,
    cancel: `Cancel`,
    editDescription: `Edit Description`,
    addAtTheStartOfThe: `Add at the start of the description`,
    addAtTheEndOfThe: `Add at the end of the description`,
    addBetweenTheDescription: `Add between the description`,
    replaceWith38: `Replace with`,
    rupiah: `Rp`,
    cny: `CNY`,
    chooseStoreLimit: `Choose at least 1 destination store to copy Product`,
    editDefaultPrice: `Edit Default Price`,
    changePriceTo: `Change price to`,
    addByAmount: `Add by amount`,
    reduceByAmount: `Reduce by amount`,
    addByPercent: `Add by percent`,
    reduceByPercent: `Reduce by percent`,
    defaultPriceError: `The default price range should be 0-1.000.000.000`,
    new: `New`,
    used: `Used`,
    chooseDestinationStore: `Choose destination store`,
    selectStore: `Select Store`,
    pleaseEnter: `Please Enter`,
    selectCategories: `Select Categories`,
    ProductDescriptionShouldBeCharacters: `Product description should be 1-7000 characters`,
    mainPhotos: `Main Photos`,
    variationImageInfo: `Edit Variant Image:`,
    master: `Master Product`,
    ProductImage: `Product Image`,
    masterCategory: `Master Category`,
    ProductDescription: `Long description`,
    variantName: `Variant Name`,
    variantImage: `variant image`,
    defaultPrice: `Default price`,
    availableStock: `Available Stock`,
    masterSku: `Master SKU`,
    packageSize: `Package Size((CM)`,
    length: `Length`,
    width: `Width`,
    height: `Height`,
    weight: `Weight(g)`,
    minPurchaseQuantity: `Min. purchase quantity`,
    createTime: `Create time`,
    updateTime: `Update time`,
    action: `Action`,
    delete: `Delete`,
    saveUpdate: `Save Update`,
    cancelUpdateConfirm: `Are sure you want to discard this change?`,
    select: `Select`,
    pleaseSelect: `Please Select`,
    viewNow: `View Now`,
    popupResultButton: `view Failed Data`,
    masterProductsImage: `Master Products & Image`,
    brand: `Brand`,
    whatsInTheBox: `What's in the box`,
    viewMore: `View more`,
    viewLess: `View less`,
    totalNumber: `Total Number`,
    successNumber: `Success Number`,
    failedNumber: `Failed Number`,
    close: `Close`,
    downloadFailedData: `Download Failed Data`,
    storeNameA: `Store Name`,
    clickToEdit: `Click on the information in the table to edit.`,
    storeWarehouse: `Store / Warehouse`,
    productInfoSetting: `Product Information Settings`,
    editStatusError: `Please click the Confirm button first, and then click Publish To Store`,
    channelCategoryAttribute: `{channel} category attribute`,
    addAttributeValue: `Add attribute value`,
    canNotInputChineseLanguage: `Can not input Chinese language`,
    pleaseChoose: `Please Choose`,
    NoBrand: `No Brand`
  },
  zh: {
    remove: `\u79FB\u9664`,
    categoryCannotBeEmpty: `\u7C7B\u76EE\u4E0D\u80FD\u4E3A\u7A7A`,
    toBatchEditingOfMainProducts: `\u201C\u6279\u91CF\u7F16\u8F91\u4E3B\u5546\u54C1\u201D\u7684\u64CD\u4F5C\u6307\u80FD`,
    toPublishToTheStoreHow: `\u201C\u53D1\u5E03\u5230\u5E97\u94FA\u201D\u7684\u64CD\u4F5C\u6307\u5357`,
    previous: `\u4E0A\u4E00\u6B65`,
    percentageLimit: `\u767E\u5206\u6BD4\u8303\u56F4\u5E94\u662F0-100,000`,
    purchasePriceLimit: `\u91D1\u989D\u5FC5\u987B\u57280 \u301C 1,000,000,000\u4E4B\u95F4\uFF01`,
    WorkingDaysBetween: `\u57287-90\u5DE5\u4F5C\u65E5\u5185`,
    beBetweenWorkingHoursMust: `\u8303\u56F4\u5E94\u662F1\uFF5E8\u5DE5\u4F5C\u5C0F\u65F6`,
    updatedSuccessfully: `\u66F4\u65B0\u6210\u529F`,
    orderProcessingTimeFollowsTheShops: `\u8BA2\u5355\u5904\u7406\u65F6\u95F4\u9075\u5FAA\u5546\u5E97\u7684\u8BBE\u7F6E`,
    categoryLazada: `Lazada\u7C7B\u76EE`,
    categoryBukalapak: `Bukalapak\u7C7B\u76EE`,
    categoryTokopedia: `Tokopedia\u7C7B\u76EE`,
    categoryShopee: `Shopee\u7C7B\u76EE`,
    ProductDescriptionShort: `\u77ED\u63CF\u8FF0`,
    publishTo: `\u53D1\u5E03\u5230`,
    viewDtails: `\u67E5\u770B\u8BE6\u60C5`,
    toViewTheMassOperationRecords1: `\u5DF2\u652F\u6301\u67E5\u770B\u8FD17\u5929\u7684\u6279\u91CF\u64CD\u4F5C\u8BB0\u5F55`,
    selectedMasterProductHasBeenCopied: `\u5DF2\u9009\u4E3B\u5546\u54C1\u5DF2\u514B\u9686\u5230\u76EE\u6807\u5E97\u94FA\u8349\u7A3F\uFF0C\u8BF7\u6309\u6E20\u9053\u7EF4\u5EA6\u7F16\u8F91\u8865\u5168\u4FE1\u606F\u540E\u518D\u53D1\u5E03\u5230\u5E97\u94FA`,
    productName: `\u5546\u54C1\u540D\u79F0`,
    productNameLimit: `\u5546\u54C1\u540D\u79F0\u5E94\u8BE5\u662F5-300\u4E2A\u5B57\u7B26`,
    variationImageSizeLimit: `\u53EF\u4EE5\u4E00\u6B21\u4E0A\u4F20\u591A\u5F20\u56FE\u50CF\u3002 \u56FE\u7247\u5927\u5C0F\u6700\u5C0F300 x 300\u50CF\u7D20\uFF0C\u6700\u5927\u4E3A5MB\uFF08\u6700\u591A8\u5F20\uFF09`,
    customDisplayInformation: `\u81EA\u5B9A\u4E49\u5C55\u793A\u4FE1\u606F`,
    mass: `\u6279\u91CF`,
    add: `\u6DFB\u52A0`,
    editProductImage: `\u7F16\u8F91\u5546\u54C1\u56FE\u7247:`,
    massEditProductName: `\u6279\u91CF\u7F16\u8F91\u5546\u54C1\u540D\u79F0`,
    massEditDimensionsCm: `\u6279\u91CF\u7F16\u8F91\u5C3A\u5BF8\uFF08Cm\uFF09`,
    max: `\u6700\u957F999,999`,
    max7: `\u6700\u5927500,000`,
    massEditWeightG: `\u6279\u91CF\u7F16\u8F91\u91CD\u91CF(g)`,
    massEditMinPurchaseQuantity: `\u6279\u91CF\u7F16\u8F91\u6700\u5C0F\u8D2D\u4E70\u6570\u91CF`,
    changeMinPurchaseQuantityTo: `\u6700\u5C0F\u8D2D\u4E70\u6570\u91CF\u6539\u6210`,
    max11: `\u6700\u59271000`,
    minPurchaseQuantityShouldBe: `\u6700\u5C0F\u8D2D\u4E70\u6570\u91CF\u5E94\u8BE5\u662F1-1000`,
    massEditAvailableStock: `\u6279\u91CF\u7F16\u8F91\u53EF\u7528\u5E93\u5B58`,
    theInventoryOfTheMasterProduct: `\u4E3B\u5546\u54C1\u7684\u5E93\u5B58\u7EDF\u4E00\u5728\u3010\u5E93\u5B58\u7BA1\u7406\u3011\u4E2D\u7BA1\u7406\uFF0C\u8BF7\u524D\u5F80\u5E76\u6279\u91CF\u4FEE\u6539\u5DF2\u9009\u5546\u54C1\u7684\u4ED3\u5E93\u5E93\u5B58\uFF08\u53EF\u7528\u5E93\u5B58=\u4ED3\u5E93\u5E93\u5B58-\u5907\u7528\u5E93\u5B58-\u9501\u5B9A\u5E93\u5B58-\u6D3B\u52A8\u5E93\u5B58\uFF09`,
    goToEdit: `\u524D\u5F80\u4FEE\u6539`,
    condition: `\u5546\u54C1\u72B6\u6001`,
    massEditCondition: `\u6279\u91CF\u7F16\u8F91\u5546\u54C1\u72B6\u6001`,
    chooseACountry: `\u9009\u62E9\u56FD\u5BB6/\u5730\u533A`,
    nextStep: `\u4E0B\u4E00\u6B65`,
    saveUpdateAndNextStep: `\u4FDD\u5B58\u5E76\u4E0B\u4E00\u6B65`,
    partOfTheMasterProductIs: `\u6309\u6E20\u9053\u5E97\u94FA\u53D1\u5E03\u5546\u54C1\u7684\u8981\u6C42\uFF0C\u4E3B\u5546\u54C1\u90E8\u5206\u5B57\u6BB5\u8981\u5FC5\u586B\u3002\u8BF7\u5148\u8865\u5168\u5FC5\u586B\u5B57\u6BB5\u540E\u518D\u53D1\u5E03\u5230\u5E97\u94FA\u3002`,
    publishToTheStore: `\u53D1\u5E03\u5230\u5E97\u94FA`,
    massEdit: `\u6279\u91CF\u7F16\u8F91`,
    productNameInThisStoreIs: `\u5546\u54C1\u540D\u79F0\u5728\u8BE5\u5E97\u94FA\u5DF2\u5B58\u5728`,
    reasonForFailure: `\u7F3A\u5931\u5FC5\u586B\u4FE1\u606F\uFF0C\u8BF7\u8865\u5168`,
    lazadaCategoryAttribute: `Lazada\u5E97\u94FA\u7684\u7C7B\u76EE\u5C5E\u6027`,
    bukalapakCategoryAttribute: `Bukalapak\u5E97\u94FA\u7684\u7C7B\u76EE\u5C5E\u6027`,
    tokopediaCategoryAttribute: `Tokopedia\u5E97\u94FA\u7684\u7C7B\u76EE\u5C5E\u6027`,
    shopeeCategoryAttribute: `Shopee\u5E97\u94FA\u7684\u7C7B\u76EE\u5C5E\u6027`,
    blibliCategoryAttribute: `Blibli\u5E97\u94FA\u7684\u7C7B\u76EE\u5C5E\u6027`,
    category: `\u7C7B\u76EE`,
    shippingSettings: `\u7269\u6D41\u8BBE\u7F6E`,
    massEditProductDescription: `\u6279\u91CF\u7F16\u8F91\u5546\u54C1\u63CF\u8FF0`,
    iNeed: `\u6211\u9700\u8981`,
    workingHours: `\u5DE5\u4F5C\u5C0F\u65F6`,
    applyToAllProducts: `\u5E94\u7528\u5230\u5168\u90E8\u5546\u54C1`,
    theValueJustEnteredWantIt: `\u521A\u5F55\u5165\u7684\u503C\uFF0C\u662F\u5426\u5E94\u7528\u4E8E\u540C\u7C7B\u76EE\u7684\u5168\u90E8\u5546\u54C1`,
    masterProductVariantType2: `\u5339\u914D\u4E3B\u5546\u54C1\u8DDF\u76EE\u6807\u5E97\u94FA\u7684\u89C4\u683C\u7C7B\u578B`,
    masterProductVariantType: `\u4E3B\u5546\u54C1 \u89C4\u683C\u7C7B\u578B`,
    matchVariantType: `\u5339\u914D\u89C4\u683C\u7C7B\u578B`,
    matchTokopediaVariantType: `\u5339\u914Dtokopeida\u7684\u89C4\u683C\u7C7B\u578B`,
    massEditOfShopeesCategoryAttribute: `\u6279\u91CF\u7F16\u8F91Shopee\u5E97\u94FA\u7684\u7C7B\u76EE\u5C5E\u6027`,
    publishingToChannelStores: `\u6B63\u5728\u6279\u91CF\u53D1\u5E03\u5230\u6E20\u9053\u5E97\u94FA`,
    productsWereSuccessfullyPublished: `29\u4E2A\u5546\u54C1\u53D1\u5E03\u6210\u529F`,
    allPublished: `\u5168\u90E8\u53D1\u5E03\u6210\u529F`,
    somePublishFailed: `\u90E8\u5206\u53D1\u5E03\u5931\u8D25`,
    allPublishFailed: `\u5168\u90E8\u53D1\u5E03\u5931\u8D25`,
    taskType: `\u4EFB\u52A1\u7C7B\u578B`,
    search: `\u641C\u7D22`,
    creator: `\u521B\u5EFA\u4EBA`,
    content: `\u5185\u5BB9`,
    publishedStoreStoreStore: `\u53D1\u5E03\u7684\u5E97\u94FA\uFF1A\u5E97\u94FA1\u3001\u5E97\u94FA2`,
    taskStatus: `\u4EFB\u52A1\u72B6\u6001`,
    publishing: `\u53D1\u5E03\u4E2D`,
    successfulQtyAllQty: `\u6210\u529F\u6570\u91CF/\u5168\u90E8\u6570\u91CF`,
    massOperationHistory: `\u6279\u91CF\u64CD\u4F5C\u8BB0\u5F55`,
    theResultOfThePublishWill: `\u53D1\u5E03\u7684\u7ED3\u679C\u4F1A\u540C\u6B65\u5C55\u793A\u5728\u3010\u4E3B\u5546\u54C1-\u6279\u91CF\u64CD\u4F5C\u8BB0\u5F55\u4E2D\u3011\u4E2D`,
    theFileWillOnlyBeReserved: `\u6587\u4EF6\u4EC5\u4F1A\u4FDD\u75597\u5929\uFF0C\u8BF7\u53CA\u65F6\u67E5\u770B\u6216\u4E0B\u8F7D`,
    no: `\u5426`,
    yes: `\u662F`,
    orderProcessingDeadline: `\u8BA2\u5355\u5904\u7406\u622A\u6B62\u65E5\u671F`,
    instant: `\u77AC\u95F4`,
    regular: `\u5B9A\u671F`,
    preorder: `\u9884\u8D2D`,
    iWillShipOutWithinX: `\u6211\u5C06\u5728X\u5DE5\u4F5C\u5C0F\u65F6\u5185\u53D1\u8D27`,
    hoursWorking: `\u5DE5\u4F5C\u5C0F\u65F6`,
    mustBeBetween: `\u5FC5\u987B\u662F1-8\u4E4B\u95F4`,
    iWillShipOutWithin: `\u6211\u5C06\u57283\u4E2A\u5DE5\u4F5C\u65E5\u5185\u53D1\u8D27\u3002 \uFF08\u4E0D\u5305\u62EC\u516C\u5171\u5047\u671F\u548C\u5FEB\u9012\u670D\u52A1\u7684\u975E\u5DE5\u4F5C\u65E5\uFF09`,
    workingDays: `\u5DE5\u4F5C\u65E5`,
    between: `\u57283-30\u4E4B\u524D`,
    preorder11: `\u9884\u552E`,
    iNeedXDaysToShip: `\u6211\u9700\u8981X\u5929\u624D\u80FD\u53D1\u8D27`,
    INeed: `\u6211\u9700\u8981`,
    toShip: `\u624D\u80FD\u53D1\u5E03`,
    iNeedXWeeksToShip: `\u6211\u9700\u8981X\u5468\u624D\u80FD\u53D1\u8D27`,
    iNeedXWorkingDays: `\u6211\u9700\u8981X\u4E2A\u5DE5\u4F5C\u65E5\u624D\u80FD\u53D1\u8D27`,
    shipTime: `\u5904\u7406\u65F6\u95F4`,
    enterProcessTime: `\u8F93\u5165\u5904\u7406\u65F6\u95F4`,
    betweenDays: `\u57281-90\u5929\u5185`,
    day: `\u5929`,
    betweenWeeks: `\u57281-13\u5468\u5185`,
    week: `\u5468`,
    between21: `\u57287\uFF5E15\u4E4B\u95F4`,
    iWillShipOutWithin22: `\u6211\u5C06\u57282\u4E2A\u5DE5\u4F5C\u65E5\u5185\u53D1\u8D27\u3002 \uFF08\u4E0D\u5305\u62EC\u516C\u5171\u5047\u671F\u548C\u5FEB\u9012\u670D\u52A1\u7684\u975E\u5DE5\u4F5C\u65E5\uFF09`,
    lengthShouldBeBetween: `\u957F\u7684\u8303\u56F4\u5E94\u662F1-999,999!`,
    widthShouldBeBetween: `\u5BBD\u7684\u8303\u56F4\u5E94\u662F1-999,999!`,
    heightShouldBeBetween: `\u9AD8\u7684\u8303\u56F4\u5E94\u662F1-999,999!`,
    weightShouldBeBetween: `\u91CD\u91CF\u7684\u8303\u56F4\u5E94\u662F1-5,000,000!`,
    editProductName: `\u7F16\u8F91\u5546\u54C1\u540D\u79F0`,
    addBeforeName: `\u540D\u79F0\u5F00\u5934\u6DFB\u52A0`,
    addAfterName: `\u540D\u79F0\u7ED3\u5C3E\u6DFB\u52A0`,
    addBetweenName: `\u540D\u79F0\u4E2D\u6DFB\u52A0`,
    replaceWith: `\u66FF\u6362\u4E3A`,
    confirm: `\u786E\u8BA4`,
    cancel: `\u53D6\u6D88`,
    editDescription: `\u7F16\u8F91\u5546\u54C1\u63CF\u8FF0`,
    addAtTheStartOfThe: `\u63CF\u8FF0\u5F00\u5934\u6DFB\u52A0`,
    addAtTheEndOfThe: `\u63CF\u8FF0\u7ED3\u5C3E\u6DFB\u52A0`,
    addBetweenTheDescription: `\u63CF\u8FF0\u4E2D\u6DFB\u52A0`,
    replaceWith38: `\u66FF\u6362\u4E3A`,
    rupiah: `\u5370\u5C3C\u76FE`,
    cny: `\u4EBA\u6C11\u5E01`,
    chooseStoreLimit: `\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u5BB6\u76EE\u6807\u5E97\u94FA`,
    editDefaultPrice: `\u7F16\u8F91\u9ED8\u8BA4\u552E\u4EF7`,
    changePriceTo: `\u76F4\u63A5\u5C06\u4EF7\u683C\u6539\u6210`,
    addByAmount: `\u6309\u91D1\u989D\u589E\u52A0`,
    reduceByAmount: `\u6309\u91D1\u989D\u51CF\u5C11`,
    addByPercent: `\u6309\u767E\u5206\u6BD4\u589E\u52A0`,
    reduceByPercent: `\u6309\u767E\u5206\u51CF\u5C11`,
    defaultPriceError: `\u9ED8\u8BA4\u552E\u4EF7\u8303\u56F4\u5E94\u8BE5\u662F0-1000,000,000`,
    new: `\u5168\u65B0`,
    used: `\u4E8C\u624B`,
    chooseDestinationStore: `\u9009\u62E9\u76EE\u6807\u5E97\u94FA`,
    selectStore: `\u9009\u62E9\u5E97\u94FA`,
    pleaseEnter: `\u8BF7\u8F93\u5165`,
    selectCategories: `\u8BF7\u9009\u62E9\u7C7B\u76EE`,
    ProductDescriptionShouldBeCharacters: `\u5546\u54C1\u957F\u63CF\u8FF0\u5E94\u662F 1 - 7000 \u4E2A\u5B57\u7B26`,
    mainPhotos: `\u5C01\u9762\u56FE\u7247`,
    variationImageInfo: `\u7F16\u8F91\u89C4\u683C\u56FE\u7247:`,
    master: `\u4E3B\u5546\u54C1`,
    ProductImage: `\u5546\u54C1\u56FE\u7247`,
    masterCategory: `\u4E3B\u7C7B\u76EE`,
    ProductDescription: `\u5546\u54C1\u957F\u63CF\u8FF0`,
    variantName: `\u89C4\u683C\u540D\u79F0`,
    variantImage: `\u89C4\u683C\u56FE\u7247`,
    defaultPrice: `\u9ED8\u8BA4\u552E\u4EF7`,
    availableStock: `\u53EF\u7528\u5E93\u5B58`,
    masterSku: `\u4E3BSKU`,
    packageSize: `\u5305\u88F9\u5C3A\u5BF8(CM)`,
    length: `\u957F`,
    width: `\u5BBD`,
    height: `\u9AD8`,
    weight: `\u91CD\u91CF(g)`,
    minPurchaseQuantity: `\u6700\u5C0F\u8D2D\u4E70\u6570\u91CF`,
    createTime: `\u521B\u5EFA\u65F6\u95F4`,
    updateTime: `\u66F4\u65B0\u65F6\u95F4`,
    action: `\u64CD\u4F5C`,
    delete: `\u5220\u9664`,
    saveUpdate: `\u4FDD\u5B58\u66F4\u65B0`,
    cancelUpdateConfirm: `\u4F60\u786E\u5B9A\u8981\u653E\u5F03\u8FD9\u6B21\u66F4\u65B0\u5417\uFF1F`,
    select: `\u8BF7\u9009\u62E9`,
    pleaseSelect: `\u8BF7\u9009\u62E9`,
    viewNow: `\u9A6C\u4E0A\u67E5\u770B`,
    popupResultButton: `\u67E5\u770B\u5931\u8D25\u6570\u636E`,
    masterProductsImage: `\u4E3B\u5546\u54C1&\u56FE\u7247`,
    brand: `\u54C1\u724C`,
    whatsInTheBox: `\u5305\u88F9\u5185\u5BB9`,
    viewMore: `\u5C55\u5F00`,
    viewLess: `\u6536\u8D77`,
    totalNumber: `\u603B\u6570\u91CF`,
    successNumber: `\u6210\u529F\u6570\u91CF`,
    failedNumber: `\u5931\u8D25\u6570\u91CF`,
    close: `\u5173\u95ED`,
    downloadFailedData: `\u4E0B\u8F7D\u5931\u8D25\u6570\u636E`,
    storeNameA: `\u5E97\u94FA\u540D\u79F0`,
    clickToEdit: `\u70B9\u51FB\u8868\u683C\u4E2D\u7684\u5185\u5BB9\uFF0C\u53EF\u8FDB\u884C\u7F16\u8F91\u64CD\u4F5C\uFF01`,
    storeWarehouse: `\u5E97\u94FA/\u4ED3\u5E93`,
    productInfoSetting: `\u5546\u54C1\u4FE1\u606F\u8BBE\u7F6E`,
    editStatusError: `\u8BF7\u5148\u70B9\u51FB\u786E\u8BA4\u6309\u94AE\u540E\uFF0C\u518D\u70B9\u51FB\u53D1\u5E03\u5230\u5E97\u94FA`,
    channelCategoryAttribute: `{channel}\u5E97\u94FA\u7684\u7C7B\u76EE\u5C5E\u6027`,
    addAttributeValue: `\u6DFB\u52A0\u5C5E\u6027\u503C`,
    canNotInputChineseLanguage: `\u4E0D\u53EF\u4EE5\u8F93\u5165\u4E2D\u6587`,
    pleaseChoose: `\u8BF7\u9009\u62E9`,
    NoBrand: `\u65E0\u54C1\u724C`
  },
  id: {
    remove: `Hapus`,
    categoryCannotBeEmpty: `Kategori tidak boleh kosong`,
    toBatchEditingOfMainProducts: `Cara "Pengeditan Batch Produk Master"\uFF1F`,
    toPublishToTheStoreHow: `Cara "Pengeditan Batch Produk Utama"\uFF1F`,
    previous: `Sebelumnya`,
    percentageLimit: `Kisaran persentase harus 0-100,000`,
    purchasePriceLimit: `Harga Beli Harus diantara 0-1,000,000,000`,
    WorkingDaysBetween: `Antara 7-90  hari kerja`,
    beBetweenWorkingHoursMust: `Harus diantara 1-8 jam kerja`,
    updatedSuccessfully: `Berhasil diperbarui`,
    orderProcessingTimeFollowsTheShops: `Waktu proses pesanan mengikuti pengaturan di lapak`,
    categoryLazada: `kategori Lazada`,
    categoryBukalapak: `kategori Bukalapak`,
    categoryTokopedia: `kategori Tokopedia`,
    categoryShopee: `kategori Shopee`,
    ProductDescriptionShort: `Deskripsi`,
    publishTo: `Tampilkan ke`,
    viewDtails: `Lihat Rincian`,
    toViewTheMassOperationRecords1: `Sekarang dapat melihat riwayat pengoperasian massal Anda`,
    selectedMasterProductHasBeenCopied: `Produk Master yang dipilih telah disalin ke draft di toko tujuan, harap edit dan lengkapi informasi sesuai dengan ketentuan Channel sebelum ditampilkan ke toko`,
    productName: `Nama Produk`,
    productNameLimit: `Nama Produk harus terdiri dari 5-300 karakter`,
    variationImageSizeLimit: `Anda dapat upload beberapa foto secara bersamaan. minimal 300 x 300 pixel \uFF0Chingga 5MB (maks 8 foto)`,
    customDisplayInformation: `Kustomisasi Tampilan Informasi`,
    mass: `Massal`,
    add: `Tambahkan`,
    editProductImage: `Edit Gambar Produk:`,
    massEditProductName: `Edit Massal Nama Produk`,
    massEditDimensionsCm: `Edit Massal Dimensi (cm)`,
    max: `Maks. 999.999`,
    max7: `Maks. 500.000`,
    massEditWeightG: `Edit Massal Berat (G)`,
    massEditMinPurchaseQuantity: `Edit Massal min. Jumlah pembelian`,
    changeMinPurchaseQuantityTo: `Edit Min. Jumlah Pembelian jadi`,
    max11: `Maks. 1000`,
    minPurchaseQuantityShouldBe: `Min. Jumlah Pembelian harus 1-1000`,
    massEditAvailableStock: `Edit Massal Stok Tersedia`,
    theInventoryOfTheMasterProduct: `Stok produk induk dikelola dalam [Manajemen Stok], silakan pergi ke manajemen Stok Gudang untuk edit stok dari produk yang dipilih\uFF08Stok Tersedia = Stok Gudang-Stok Cadangan-Stok Terkunci-Stok Promosi\uFF09`,
    goToEdit: `Edit Sekarang`,
    condition: `Kondisi`,
    massEditCondition: `Edit Massal Kondisi`,
    chooseACountry: `Pilih Negara/Wilayah`,
    nextStep: `Selanjutnya`,
    saveUpdateAndNextStep: `Simpan dan Selanjutnya`,
    partOfTheMasterProductIs: `Menurut aturan Channel toko, beberapa informasi di Master Produk wajib diisi. Silahkan isi informasi yang diperlukan sebelum ditampilkan di toko.`,
    publishToTheStore: `Tampilkan ke toko`,
    massEdit: `Edit Massal`,
    productNameInThisStoreIs: `Nama Produk di Toko ini telah ada`,
    reasonForFailure: `informasi yang diperlukan tidak ada, mohon dilengkapi`,
    lazadaCategoryAttribute: `Atribut kategori Lazada`,
    bukalapakCategoryAttribute: `Atribut kategori Bukalapak`,
    tokopediaCategoryAttribute: `Atribut kategori Tokopedia`,
    shopeeCategoryAttribute: `Atribut kategori Shopee`,
    blibliCategoryAttribute: `Atribut kategori Blibli`,
    category: `Kategori`,
    shippingSettings: `Pengaturan Pengiriman`,
    massEditProductDescription: `Edit Massal Deskripsi Produk`,
    iNeed: `Saya Butuh`,
    workingHours: `Jam Kerja`,
    applyToAllProducts: `Terapkan ke semua produk`,
    theValueJustEnteredWantIt: `Apa Anda ingin menerapkan data ini pada semua produk dari kategori yang sama?`,
    masterProductVariantType2: `Cocokkan jenis varian produk Master dengan toko target`,
    masterProductVariantType: `Tipe Varian Produk Master`,
    matchVariantType: `Cocokan dengan Tipe Varian`,
    matchTokopediaVariantType: `Cocokan dengan Tipe Varian Tokopedia`,
    massEditOfShopeesCategoryAttribute: `Edit Massal atribut kategori Shopee`,
    publishingToChannelStores: `Menampilkan ke Toko Channel`,
    productsWereSuccessfullyPublished: `29 produk berhasil ditampilkan`,
    allPublished: `Semua berhasil ditampilkan`,
    somePublishFailed: `Beberapa gagal ditampilkan`,
    allPublishFailed: `Semua gagal ditampilkan`,
    taskType: `Tipe Tugas`,
    search: `Cari`,
    creator: `Pembuat`,
    content: `Konten`,
    publishedStoreStoreStore: `Ditampilkan ke Toko: Toko 1, Toko 2`,
    taskStatus: `Status Tugas`,
    publishing: `Menampilkan`,
    successfulQtyAllQty: `Jumlah Sukses / Jumlah Total`,
    massOperationHistory: `Riwayat Operasi Massal`,
    theResultOfThePublishWill: `Hasil Ditampilkan akan disinkronkan di [Produk Master - Riwayat Operasi Massal]`,
    theFileWillOnlyBeReserved: `File hanya akan disediakan selama 7 hari, silakan periksa atau unduh.`,
    no: `Tidak`,
    yes: `Ya`,
    orderProcessingDeadline: `Batas Waktu Proses Pesanan`,
    instant: `Instan`,
    regular: `Reguler`,
    preorder: `Preorder`,
    iWillShipOutWithinX: `Saya akan mengirimkan pesanan dalam x jam kerja`,
    hoursWorking: `jam kerja`,
    mustBeBetween: `Harus diantara 1-8`,
    iWillShipOutWithin: `Saya akan mengirimkan pesanan dalam 3 hari kerja (tidak termasuk hari libur dan jadwal libur logistik)`,
    workingDays: `hari kerja`,
    between: `Antara 3-30`,
    preorder11: `Preorder`,
    iNeedXDaysToShip: `Saya butuh X hari untuk melakukan pengiriman`,
    INeed: `Saya butuh`,
    toShip: `untuk melakukan pengiriman`,
    iNeedXWeeksToShip: `Saya butuh X minggu untuk melakukan pengiriman`,
    iNeedXWorkingDays: `Saya butuh X hari kerja untuk melakukan pengiriman`,
    shipTime: `Waktu Proses`,
    enterProcessTime: `Masukkan Waktu Proses`,
    betweenDays: `Antara 1-90 Hari`,
    day: `Hari`,
    betweenWeeks: `Antara 1-13 minggu`,
    week: `Minggu`,
    between21: `Antara 7-15`,
    iWillShipOutWithin22: `Saya akan mengirimkan pesanan dalam 2 hari kerja (tidak termasuk hari libur dan jadwal libur logistik)`,
    lengthShouldBeBetween: `Panjang Harus antara 1-999,999!`,
    widthShouldBeBetween: `Lebar Harus antara 1-999,999!`,
    heightShouldBeBetween: `Tinggi Harus antara 1-999,999!`,
    weightShouldBeBetween: `Berat Harus antara 1-5,000,000!`,
    editProductName: `Edit Nama Produk`,
    addBeforeName: `Tambahkan sebelum nama`,
    addAfterName: `Tambahkan setelah nama`,
    addBetweenName: `Tambahkan di antara nama`,
    replaceWith: `Ganti dengan`,
    confirm: `Konfirmasi`,
    cancel: `Batalkan`,
    editDescription: `Edit Deskripsi`,
    addAtTheStartOfThe: `Tambahkan di awal deskripsi`,
    addAtTheEndOfThe: `Tambahkan di akhir deskripsi`,
    addBetweenTheDescription: `Tambahkan di antara deskripsi`,
    replaceWith38: `Ganti dengan`,
    rupiah: `Rp`,
    cny: `CNY`,
    chooseStoreLimit: `Pilih setidaknya 1 Toko tujuan untuk salin produk`,
    editDefaultPrice: `Edit Harga Awal`,
    changePriceTo: `Edit harga jadi`,
    addByAmount: `Tambah berdasarkan jumlah`,
    reduceByAmount: `Kurangi berdasarkan jumlah`,
    addByPercent: `Tambah berdasarkan presentase`,
    reduceByPercent: `Kurangi berdasarkan presentase`,
    defaultPriceError: `Kisaran harga default harus diantara 0-1.000.000.000`,
    new: `Baru`,
    used: `Bekas`,
    chooseDestinationStore: `Pilih Toko tujuan salin produk`,
    selectStore: `Pilih Toko`,
    pleaseEnter: `Silakan Masukkan`,
    selectCategories: `Pilih Kategori`,
    ProductDescriptionShouldBeCharacters: `Deskripsi produk harus terdiri dari 1-7000 karakter`,
    mainPhotos: `Foto Utama`,
    variationImageInfo: `Edit Gambar Varian:`,
    master: `Master Produk`,
    ProductImage: `Gambar Produk`,
    masterCategory: `Kategori Master`,
    ProductDescription: `Deskripsi Produk`,
    variantName: `Nama Varian`,
    variantImage: `gambar varian`,
    defaultPrice: `Harga Default`,
    availableStock: `Stok Tersedia`,
    masterSku: `Master SKU`,
    packageSize: `Ukuran Paket(CM)`,
    length: `Panjang`,
    width: `Lebar`,
    height: `Tinggi`,
    weight: `Berat(g)`,
    minPurchaseQuantity: `Jumlah pembelian Min.`,
    createTime: `Waktu Pembuatan`,
    updateTime: `Waktu Pembaruan`,
    action: `Atur`,
    delete: `Menghapus`,
    saveUpdate: `Simpan Pembaruan`,
    cancelUpdateConfirm: `Yakin ingin membatalkan perubahan ini?`,
    select: `pilih`,
    pleaseSelect: `Silahkan pilih`,
    viewNow: `Lihat sekarang`,
    popupResultButton: `Lihat Data yang Gagal`,
    masterProductsImage: `Master Produk & Gambar`,
    brand: `Merek`,
    whatsInTheBox: `Apa yang didalam kemasan`,
    viewMore: `Lihat lebih banyak`,
    viewLess: `Lihat lebih sedikit`,
    totalNumber: `Jumlah Total`,
    successNumber: `Jumlah Berhasil`,
    failedNumber: `Jumlah Gagal`,
    close: `Tutup`,
    downloadFailedData: `Unduh Data yang Gagal`,
    storeNameA: `Nama Toko`,
    clickToEdit: `Klik pada informasi di tabel untuk mengedit.`,
    storeWarehouse: `Toko/Gudang`,
    productInfoSetting: `Pengaturan Informasi Produk`,
    editStatusError: `Silakan klik tombol Konfirmasi terlebih dahulu, lalu klik Tampilkan Ke Toko`,
    channelCategoryAttribute: `Atribut kategori {channel}`,
    addAttributeValue: `Tambahkan nilai atribut`,
    canNotInputChineseLanguage: `Tidak bisa menginput Mandarin`,
    pleaseChoose: `Silahkan Pilih`,
    NoBrand: `Tidak Ada Merek`
  },
  th: {
    remove: `\u0E25\u0E1A`,
    categoryCannotBeEmpty: `\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E27\u0E49\u0E19\u0E27\u0E48\u0E32\u0E07\u0E44\u0E14\u0E49`,
    toBatchEditingOfMainProducts: `\u0E27\u0E34\u0E18\u0E35 "\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21"`,
    toPublishToTheStoreHow: `\u0E27\u0E34\u0E18\u0E35 "\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32"`,
    previous: `\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32`,
    percentageLimit: `\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E40\u0E1B\u0E2D\u0E23\u0E4C\u0E40\u0E0B\u0E47\u0E19\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E48\u0E39\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 0-100,000`,
    purchasePriceLimit: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 0 \u301C 1,000,000,000`,
    WorkingDaysBetween: `\u0E20\u0E32\u0E22\u0E43\u0E19 7-90 \u0E27\u0E31\u0E19\u0E17\u0E33\u0E01\u0E32\u0E23`,
    beBetweenWorkingHoursMust: `\u0E0A\u0E48\u0E27\u0E07\u0E04\u0E27\u0E23\u0E40\u0E1B\u0E47\u0E19 1\uFF5E8 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07\u0E17\u0E33\u0E07\u0E32\u0E19`,
    updatedSuccessfully: `\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    orderProcessingTimeFollowsTheShops: `\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E08\u0E30\u0E15\u0E32\u0E21\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    categoryLazada: `\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48 Lazada`,
    categoryBukalapak: `\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48 Bukalapak`,
    categoryTokopedia: `\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48 Tokopedia`,
    categoryShopee: `\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48 Shopee`,
    ProductDescriptionShort: `\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    publishTo: `\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E44\u0E1B\u0E22\u0E31\u0E07`,
    viewDtails: `\u0E14\u0E39\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14`,
    toViewTheMassOperationRecords1: `\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E14\u0E39\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E43\u0E19\u0E0A\u0E48\u0E27\u0E07 7 \u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32`,
    selectedMasterProductHasBeenCopied: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E09\u0E1A\u0E31\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E43\u0E19\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E41\u0E01\u0E49\u0E44\u0E02\u0E41\u0E25\u0E30\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E2B\u0E49\u0E04\u0E23\u0E1A\u0E16\u0E49\u0E27\u0E19\u0E15\u0E32\u0E21\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E02\u0E2D\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E01\u0E48\u0E2D\u0E19\u0E17\u0E35\u0E48\u0E08\u0E30\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    productName: `\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    productNameLimit: `\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 5 - 300 \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23`,
    variationImageSizeLimit: `\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E44\u0E14\u0E49\u0E2B\u0E25\u0E32\u0E22\u0E20\u0E32\u0E1E\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E01\u0E31\u0E19 \u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 300 x 300 \u0E1E\u0E34\u0E01\u0E40\u0E0B\u0E25 \u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 5MB (\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 8 \u0E20\u0E32\u0E1E)`,
    customDisplayInformation: `\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07`,
    mass: `\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    add: `\u0E40\u0E1E\u0E34\u0E48\u0E21`,
    editProductImage: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    massEditProductName: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    massEditDimensionsCm: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E19\u0E32\u0E14(cm)\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    max: `\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14999,999`,
    max7: `\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14500.000`,
    massEditWeightG: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E19\u0E33\u0E49\u0E2B\u0E19\u0E31\u0E01(g)\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    massEditMinPurchaseQuantity: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E08\u0E33\u0E19\u0E27\u0E19\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E31\u0E49\u0E19\u0E15\u0E48\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    changeMinPurchaseQuantityTo: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E08\u0E33\u0E19\u0E27\u0E19\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E31\u0E49\u0E19\u0E15\u0E48\u0E33\u0E40\u0E1B\u0E47\u0E19`,
    max11: `\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 1000`,
    minPurchaseQuantityShouldBe: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E31\u0E49\u0E19\u0E15\u0E48\u0E33\u0E04\u0E27\u0E23\u0E40\u0E1B\u0E47\u0E191-1000`,
    massEditAvailableStock: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E2A\u0E48\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    theInventoryOfTheMasterProduct: `\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01\u0E08\u0E30\u0E16\u0E39\u0E01\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E1C\u0E48\u0E32\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E21\u0E19\u0E39\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E15\u0E47\u0E2D\u0E01 \u0E42\u0E1B\u0E23\u0E14\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E21\u0E19\u0E39\u0E19\u0E35\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01`,
    goToEdit: `\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E01\u0E49\u0E44\u0E02`,
    condition: `\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    massEditCondition: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    chooseACountry: `\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28/\u0E20\u0E39\u0E21\u0E34\u0E20\u0E32\u0E04`,
    nextStep: `\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E15\u0E48\u0E2D\u0E44\u0E1B`,
    saveUpdateAndNextStep: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E41\u0E25\u0E30\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E15\u0E48\u0E2D\u0E44\u0E1B`,
    partOfTheMasterProductIs: `\u0E15\u0E32\u0E21\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E02\u0E2D\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E0A\u0E48\u0E2D\u0E07\u0E04\u0E2D\u0E25\u0E31\u0E21\u0E19\u0E4C\u0E1A\u0E32\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E43\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E23\u0E32\u0E2B\u0E25\u0E31\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E23\u0E2D\u0E01 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E04\u0E2D\u0E25\u0E31\u0E21\u0E19\u0E4C\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    publishToTheStore: `\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    massEdit: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    productNameInThisStoreIs: `\u0E21\u0E35\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E19\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27`,
    reasonForFailure: `\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27\uFF1A\u0E02\u0E32\u0E14\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E23\u0E2D\u0E01 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E43\u0E2B\u0E49\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C`,
    lazadaCategoryAttribute: `\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E33\u0E02\u0E2D\u0E07\u0E40\u0E1E\u0E32\u0E30\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32Lazada`,
    bukalapakCategoryAttribute: `\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E33\u0E02\u0E2D\u0E07\u0E40\u0E1E\u0E32\u0E30\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32Bukalapak`,
    tokopediaCategoryAttribute: `\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E33\u0E40\u0E1E\u0E32\u0E30\u0E02\u0E2D\u0E07\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32Tokopedia`,
    shopeeCategoryAttribute: `\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E33\u0E40\u0E1E\u0E32\u0E30\u0E02\u0E2D\u0E07\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32 Shopee`,
    blibliCategoryAttribute: `\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E33\u0E40\u0E1E\u0E32\u0E30\u0E02\u0E2D\u0E07\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32Blibli`,
    category: `\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48`,
    shippingSettings: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07`,
    massEditProductDescription: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    iNeed: `\u0E09\u0E31\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23`,
    workingHours: `\u0E40\u0E27\u0E25\u0E32\u0E17\u0E33\u0E07\u0E32\u0E19`,
    applyToAllProducts: `\u0E43\u0E0A\u0E49\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    theValueJustEnteredWantIt: `\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08, \u0E19\u0E33\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E43\u0E19\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E40\u0E14\u0E35\u0E22\u0E27\u0E01\u0E31\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?`,
    masterProductVariantType2: `\u0E08\u0E31\u0E1A\u0E04\u0E39\u0E48\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1B\u0E49\u0E32\u0E2B\u0E21\u0E32\u0E22`,
    masterProductVariantType: `\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    matchVariantType: `\u0E08\u0E31\u0E1A\u0E04\u0E39\u0E48\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1A\u0E19`,
    matchTokopediaVariantType: `\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07 tokopeida`,
    massEditOfShopeesCategoryAttribute: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E33\u0E40\u0E1E\u0E32\u0E30\u0E02\u0E2D\u0E07\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32 Shopee \u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    publishingToChannelStores: `\u0E01\u0E33\u0E25\u0E31\u0E07 \u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    productsWereSuccessfullyPublished: `\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48 29 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    allPublished: `\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    somePublishFailed: `\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19`,
    allPublishFailed: `\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    taskType: `\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E07\u0E32\u0E19`,
    search: `\u0E04\u0E49\u0E19\u0E2B\u0E32`,
    creator: `\u0E1C\u0E39\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07`,
    content: `\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32`,
    publishedStoreStoreStore: `\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\uFF1A\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E481\u3001\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E482`,
    taskStatus: `\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E07\u0E32\u0E19`,
    publishing: `\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E2D\u0E22\u0E39\u0E48`,
    successfulQtyAllQty: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08/\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    massOperationHistory: `\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    theResultOfThePublishWill: `\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E08\u0E30\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E43\u0E19\u3010\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01-\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u3011`,
    theFileWillOnlyBeReserved: `\u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E30\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E1F\u0E25\u0E4C\u0E40\u0E1E\u0E35\u0E22\u0E07 7 \u0E27\u0E31\u0E19 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E23\u0E27\u0E08\u0E14\u0E39\u0E41\u0E25\u0E30\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38`,
    no: `\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48`,
    yes: `\u0E43\u0E0A\u0E48`,
    orderProcessingDeadline: `\u0E40\u0E27\u0E25\u0E32\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14\u0E02\u0E2D\u0E07\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D`,
    instant: `\u0E17\u0E31\u0E19\u0E17\u0E35`,
    regular: `\u0E1B\u0E23\u0E01\u0E15\u0E34`,
    preorder: `\u0E1E\u0E23\u0E35\u0E2D\u0E2D\u0E40\u0E14\u0E2D\u0E23\u0E4C`,
    iWillShipOutWithinX: `\u0E09\u0E31\u0E19\u0E08\u0E30\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E20\u0E32\u0E22\u0E43\u0E19 x \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07\u0E40\u0E27\u0E25\u0E32\u0E17\u0E33\u0E01\u0E32\u0E23`,
    hoursWorking: `\u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07\u0E17\u0E33\u0E07\u0E32\u0E19`,
    mustBeBetween: `\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E071-8`,
    iWillShipOutWithin: `\u0E09\u0E31\u0E19\u0E08\u0E30\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E20\u0E32\u0E22\u0E43\u0E193\u0E27\u0E31\u0E19(\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E27\u0E31\u0E19\u0E2B\u0E22\u0E38\u0E14\u0E19\u0E31\u0E01\u0E02\u0E31\u0E15\u0E24\u0E01\u0E29\u0E4C\u0E41\u0E25\u0E30\u0E27\u0E31\u0E19\u0E2B\u0E22\u0E38\u0E14\u0E15\u0E32\u0E21\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E02\u0E19\u0E2A\u0E48\u0E07)`,
    workingDays: `\u0E27\u0E31\u0E19\u0E17\u0E33\u0E07\u0E32\u0E19`,
    between: `\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 3-30`,
    preorder11: `\u0E1E\u0E23\u0E35\u0E2D\u0E2D\u0E40\u0E14\u0E2D\u0E23\u0E4C`,
    iNeedXDaysToShip: `\u0E09\u0E31\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23 x \u0E27\u0E31\u0E19\u0E16\u0E36\u0E07\u0E08\u0E30\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E14\u0E49`,
    INeed: `\u0E09\u0E31\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23`,
    toShip: `\u0E08\u0E30\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E44\u0E14\u0E49`,
    iNeedXWeeksToShip: `\u0E09\u0E31\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23 x \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C\u0E16\u0E36\u0E07\u0E08\u0E30\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E14\u0E49`,
    iNeedXWorkingDays: `\u0E09\u0E31\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23 x \u0E27\u0E31\u0E19\u0E17\u0E33\u0E07\u0E32\u0E19\u0E16\u0E36\u0E07\u0E08\u0E30\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E14\u0E49`,
    shipTime: `\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    enterProcessTime: `\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E27\u0E25\u0E32\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    betweenDays: `\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E071-90\u0E27\u0E31\u0E19`,
    day: `\u0E27\u0E31\u0E19`,
    betweenWeeks: `\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E071-13 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C`,
    week: `\u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C`,
    between21: `\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E077\uFF5E15`,
    iWillShipOutWithin22: `\u0E09\u0E31\u0E19\u0E08\u0E30\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E31\u0E32\u0E20\u0E32\u0E22\u0E43\u0E19 2 \u0E27\u0E31\u0E19\u0E17\u0E33\u0E07\u0E32\u0E19(\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E27\u0E31\u0E19\u0E2B\u0E22\u0E38\u0E14\u0E19\u0E31\u0E01\u0E02\u0E31\u0E15\u0E24\u0E01\u0E29\u0E4C\u0E41\u0E25\u0E30\u0E27\u0E31\u0E19\u0E2B\u0E22\u0E38\u0E14\u0E15\u0E32\u0E21\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E02\u0E19\u0E2A\u0E48\u0E07)`,
    lengthShouldBeBetween: `\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E071-999,999!`,
    widthShouldBeBetween: `\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E04\u0E27\u0E32\u0E21\u0E01\u0E27\u0E49\u0E32\u0E07\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E071-999,999!`,
    heightShouldBeBetween: `\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E39\u0E07\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E071-999,999!`,
    weightShouldBeBetween: `\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E19\u0E33\u0E49\u0E2B\u0E19\u0E31\u0E01\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E071-5,000,000!`,
    editProductName: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    addBeforeName: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2B\u0E19\u0E49\u0E32\u0E0A\u0E37\u0E48\u0E2D`,
    addAfterName: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2B\u0E25\u0E31\u0E07\u0E0A\u0E37\u0E48\u0E2D`,
    addBetweenName: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E0A\u0E37\u0E48\u0E2D`,
    replaceWith: `\u0E41\u0E17\u0E19\u0E14\u0E49\u0E27\u0E22`,
    confirm: `\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19`,
    cancel: `\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01`,
    editDescription: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    addAtTheStartOfThe: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E43\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E40\u0E23\u0E34\u0E48\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22`,
    addAtTheEndOfThe: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E43\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E17\u0E49\u0E32\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22`,
    addBetweenTheDescription: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E43\u0E19\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22`,
    replaceWith38: `\u0E41\u0E17\u0E19\u0E14\u0E49\u0E27\u0E22`,
    rupiah: `\u0E23\u0E39\u0E40\u0E1B\u0E35\u0E22\u0E2B\u0E4C`,
    cny: `\u0E2B\u0E22\u0E27\u0E19`,
    chooseStoreLimit: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 1 \u0E23\u0E49\u0E32\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    editDefaultPrice: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E32\u0E04\u0E32\u0E15\u0E31\u0E49\u0E07\u0E15\u0E49\u0E19`,
    changePriceTo: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E32\u0E04\u0E32\u0E40\u0E1B\u0E47\u0E19`,
    addByAmount: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E15\u0E32\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19`,
    reduceByAmount: `\u0E25\u0E14\u0E15\u0E32\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19`,
    addByPercent: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E15\u0E32\u0E21\u0E40\u0E1B\u0E2D\u0E23\u0E4C\u0E40\u0E0B\u0E47\u0E19\u0E15\u0E4C`,
    reduceByPercent: `\u0E25\u0E14\u0E15\u0E32\u0E21\u0E40\u0E1B\u0E2D\u0E23\u0E4C\u0E40\u0E0B\u0E47\u0E19\u0E15\u0E4C`,
    defaultPriceError: `\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E23\u0E32\u0E04\u0E32\u0E02\u0E32\u0E22\u0E15\u0E31\u0E49\u0E07\u0E15\u0E49\u0E19\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E070-1000,000,000`,
    new: `\u0E43\u0E2B\u0E21\u0E48`,
    used: `\u0E21\u0E37\u0E2D\u0E2A\u0E2D\u0E07`,
    chooseDestinationStore: `\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23`,
    selectStore: `\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    pleaseEnter: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01`,
    selectCategories: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48`,
    ProductDescriptionShouldBeCharacters: `\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E071-7000\u0E2B\u0E25\u0E31\u0E01`,
    mainPhotos: `\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E2B\u0E25\u0E31\u0E01`,
    variationImageInfo: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    master: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    ProductImage: `\u0E23\u0E39\u0E1B\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    masterCategory: `\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E2B\u0E25\u0E31\u0E01`,
    ProductDescription: `\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    variantName: `\u0E0A\u0E37\u0E48\u0E2D\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    variantImage: `\u0E23\u0E39\u0E1B\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    defaultPrice: `\u0E23\u0E32\u0E04\u0E32\u0E15\u0E31\u0E49\u0E07\u0E15\u0E49\u0E19`,
    availableStock: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E2A\u0E48\u0E07`,
    masterSku: `SKU \u0E2B\u0E25\u0E31\u0E01`,
    packageSize: `\u0E02\u0E19\u0E32\u0E14\u0E1E\u0E31\u0E2A\u0E14\u0E38((CM)`,
    length: `\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27`,
    width: `\u0E04\u0E27\u0E32\u0E21\u0E01\u0E27\u0E49\u0E32\u0E07`,
    height: `\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E39\u0E07`,
    weight: `\u0E19\u0E33\u0E49\u0E2B\u0E19\u0E31\u0E01(g)`,
    minPurchaseQuantity: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E31\u0E49\u0E19\u0E15\u0E48\u0E33\u0E2A\u0E38\u0E14`,
    createTime: `\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07`,
    updateTime: `\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15`,
    action: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    delete: `\u0E25\u0E1A`,
    saveUpdate: `\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15`,
    cancelUpdateConfirm: `\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E44\u0E2B\u0E21\u0E17\u0E35\u0E48\u0E08\u0E30\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E04\u0E23\u0E31\u0E49\u0E07\u0E19\u0E35\u0E49?`,
    select: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01`,
    pleaseSelect: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01`,
    viewNow: `\u0E14\u0E39\u0E17\u0E31\u0E19\u0E17\u0E35`,
    popupResultButton: `\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    masterProductsImage: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01&\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E`,
    brand: `\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C`,
    whatsInTheBox: `\u0E21\u0E35\u0E2D\u0E30\u0E44\u0E23\u0E43\u0E19\u0E1E\u0E31\u0E2A\u0E14\u0E38`,
    viewMore: `\u0E14\u0E39\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21`,
    viewLess: `\u0E22\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32`,
    totalNumber: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    successNumber: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    failedNumber: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    close: `\u0E1B\u0E34\u0E14`,
    downloadFailedData: `\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    storeNameA: `\u0E0A\u0E37\u0E48\u0E2D\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    clickToEdit: `\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E25\u0E34\u0E01\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E41\u0E25\u0E30\u0E41\u0E01\u0E49\u0E44\u0E02\u0E44\u0E14\u0E49`,
    storeWarehouse: `\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32/\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    productInfoSetting: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    editStatusError: `\u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E48\u0E2D\u0E19 \u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    channelCategoryAttribute: `\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E33\u0E40\u0E1E\u0E32\u0E30\u0E02\u0E2D\u0E07\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32{channel}`,
    addAttributeValue: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E33\u0E40\u0E1E\u0E32\u0E30`,
    canNotInputChineseLanguage: `\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E49\u0E2D\u0E19\u0E20\u0E32\u0E29\u0E32\u0E08\u0E35\u0E19\u0E44\u0E14\u0E49`,
    pleaseChoose: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01`,
    NoBrand: `\u0E44\u0E21\u0E48\u0E21\u0E35\u0E22\u0E35\u0E48\u0E2B\u0E49\u0E2D`
  },
  vn: {
    remove: `X\xF3a`,
    categoryCannotBeEmpty: `Danh m\u1EE5c kh\xF4ng \u0111\u01B0\u1EE3c \u0111\u1EC3 tr\u1ED1ng`,
    toBatchEditingOfMainProducts: `L\xE0m th\u1EBF n\xE0o "Ch\u1EC9nh s\u1EEDa S\u1EA3n ph\u1EA9m ch\xEDnh?`,
    toPublishToTheStoreHow: `L\xE0m th\u1EBF n\xE0o "\u0110\u0103ng t\u1EA3i s\u1EA3n ph\u1EA9m l\xEAn c\u1EEDa h\xE0ng"?`,
    previous: `Quay l\u1EA1i`,
    percentageLimit: `T\u1EF7 l\u1EC7 ph\u1EA7n tr\u0103m ph\u1EA3i t\u1EEB 0-100.000`,
    purchasePriceLimit: `Gi\xE1 ph\u1EA3i t\u1EEB gi\u1EEFa 0-1000.000.000!`,
    WorkingDaysBetween: `Trong v\xF2ng 7-90 ng\xE0y l\xE0m vi\u1EC7c`,
    beBetweenWorkingHoursMust: `Trong v\xF2ng 1~8 ti\u1EBFng l\xE0m vi\u1EC7c`,
    updatedSuccessfully: `C\u1EADp nh\u1EADt th\xE0nh c\xF4ng`,
    orderProcessingTimeFollowsTheShops: `Th\u1EDDi gian x\u1EED l\xFD \u0111\u01A1n h\xE0ng tu\xE2n theo c\xE0i \u0111\u1EB7t c\u1EEDa h\xE0ng`,
    categoryLazada: `Danh m\u1EE5c Lazada`,
    categoryBukalapak: `Danh m\u1EE5c Bukalapak`,
    categoryTokopedia: `Danh m\u1EE5c Tokopedia`,
    categoryShopee: `Danh m\u1EE5c Shopee`,
    ProductDescriptionShort: `M\xF4 t\u1EA3 ng\u1EAFn`,
    publishTo: `\u0110\u0103ng t\u1EA1i`,
    viewDtails: `Xem chi ti\u1EBFt`,
    toViewTheMassOperationRecords1: `C\xF3 th\u1EC3 xem chi ti\u1EBFt L\u1ECBch s\u1EED thao t\xE1c trong v\xF2ng 7 ng\xE0y g\u1EA7n nh\u1EA5t`,
    selectedMasterProductHasBeenCopied: `S\u1EA3n ph\u1EA9m \u0111\u01B0\u1EE3c ch\u1ECDn \u0111\xE3 sao ch\xE9p th\xE0nh b\u1EA3n nh\xE1p trong c\u1EEDa h\xE0ng y\xEAu c\u1EA7u, vui l\xF2ng ch\u1EC9nh s\u1EEDa v\xE0 b\u1ED5 sung th\xF4ng tin theo y\xEAu c\u1EA7u c\u1EE7a k\xEAnh tr\u01B0\u1EDBc khi \u0111\u0103ng l\xEAn c\u1EEDa h\xE0ng`,
    productName: `T\xEAn S\u1EA3n ph\u1EA9m`,
    productNameLimit: `T\xEAn S\u1EA3n ph\u1EA9m ph\u1EA3i t\u1EEB 5-300 k\xFD t\u1EF1`,
    variationImageSizeLimit: `C\xF3 th\u1EC3 t\u1EA3i l\xEAn nhi\u1EC1u h\xECnh \u1EA3nh c\xF9ng l\xFAc. T\u1ED1i thi\u1EC3u 300 x 300 pix, T\u1ED1i \u0111a 5MB (T\u1ED1i \u0111a 8 h\xECnh \u1EA3nh)`,
    customDisplayInformation: `Th\xF4ng tin hi\u1EC3n th\u1ECB t\xF9y ch\u1EC9nh`,
    mass: `H\xE0ng lo\u1EA1t`,
    add: `Th\xEAm`,
    editProductImage: `Ch\u1EC9nh s\u1EEDa h\xECnh \u1EA3nh s\u1EA3n ph\u1EA9m:`,
    massEditProductName: `Ch\u1EC9nh s\u1EEDa h\xE0ng lo\u1EA1t t\xEAn s\u1EA3n ph\u1EA9m`,
    massEditDimensionsCm: `Ch\u1EC9nh s\u1EEDa k\xEDch th\u01B0\u1EDBc h\xE0ng lo\u1EA1t (Cm)`,
    max: `T\u1ED1i \u0111a 999.999`,
    max7: `T\u1ED1i \u0111a 500.000`,
    massEditWeightG: `Ch\u1EC9nh s\u1EEDa tr\u1ECDng l\u01B0\u1EE3ng h\xE0ng lo\u1EA1t`,
    massEditMinPurchaseQuantity: `Ch\u1EC9nh s\u1EEDa h\xE0ng lo\u1EA1t s\u1ED1 l\u01B0\u1EE3ng mua t\u1ED1i thi\u1EC3u`,
    changeMinPurchaseQuantityTo: `S\u1ED1 l\u01B0\u1EE3ng mua t\u1ED1i thi\u1EC3u s\u1EEDa th\xE0nh`,
    max11: `T\u1ED1i \u0111a 1000`,
    minPurchaseQuantityShouldBe: `S\u1ED1 l\u01B0\u1EE3ng mua t\u1ED1i thi\u1EC3u ph\u1EA3i t\u1EEB 1-1000`,
    massEditAvailableStock: `Ch\u1EC9nh s\u1EEDa h\xE0ng lo\u1EA1t T\u1ED3n kho d\u1EF1 ph\xF2ng`,
    theInventoryOfTheMasterProduct: `H\xE0ng t\u1ED3n kho c\u1EE7a S\u1EA3n ph\u1EA9m ch\xEDnh \u0111\u01B0\u1EE3c qu\u1EA3n l\xFD trong [Qu\u1EA3n l\xFD h\xE0ng t\u1ED3n kho], vui l\xF2ng \u0111i \u0111\u1EBFn v\xE0 ch\u1EC9nh s\u1EEDa H\xE0ng t\u1ED3n kho c\u1EE7a s\u1EA3n ph\u1EA9m \u0111\xE3 ch\u1ECDn`,
    goToEdit: `\u0110i \u0111\u1EBFn ch\u1EC9nh s\u1EEDa`,
    condition: `Tr\u1EA1ng th\xE1i s\u1EA3n ph\u1EA9m`,
    massEditCondition: `Ch\u1EC9nh s\u1EEDa Tr\u1EA1ng th\xE1i H\xE0ng lo\u1EA1t`,
    chooseACountry: `Ch\u1ECDn qu\u1ED1c gia/Khu v\u1EF1c`,
    nextStep: `Ti\u1EBFp theo`,
    saveUpdateAndNextStep: `L\u01B0u v\xE0 ti\u1EBFp theo`,
    partOfTheMasterProductIs: `Theo y\xEAu c\u1EA7u \u0111\u0103ng s\u1EA3n ph\u1EA9m c\u1EE7a k\xEAnh c\u1EEDa h\xE0ng, ph\u1EA7n s\u1EA3n ph\u1EA9m ch\xEDnh b\u1EAFt bu\u1ED9c \u0111i\u1EC1n. Vui l\xF2ng ho\xE0n th\xE0nh c\xE1c ph\u1EA7n b\u1EAFt bu\u1ED9c tr\u01B0\u1EDBc khi \u0111\u0103ng l\xEAn c\u1EEDa h\xE0ng.`,
    publishToTheStore: `\u0110\u0103ng l\xEAn c\u1EEDa h\xE0ng`,
    massEdit: `Ch\u1EC9nh s\u1EEDa h\xE0ng lo\u1EA1t`,
    productNameInThisStoreIs: `T\xEAn s\u1EA3n ph\u1EA9m \u0111\xE3 t\u1ED3n t\u1EA1i trong c\u1EEDa h\xE0ng n\xE0y`,
    reasonForFailure: `Nguy\xEAn nh\xE2n th\u1EA5t b\u1EA1i: \u0111i\u1EC1n thi\u1EBFu th\xF4ng tin, vui l\xF2ng b\u1ED5 sung`,
    lazadaCategoryAttribute: `Thu\u1ED9c t\xEDnh danh m\u1EE5c c\u1EEDa h\xE0ng Lazada`,
    bukalapakCategoryAttribute: `Thu\u1ED9c t\xEDnh danh m\u1EE5c c\u1EEDa h\xE0ng Bukalapak`,
    tokopediaCategoryAttribute: `Thu\u1ED9c t\xEDnh danh m\u1EE5c c\u1EEDa h\xE0ng Tokopedia`,
    shopeeCategoryAttribute: `Thu\u1ED9c t\xEDnh danh m\u1EE5c c\u1EE7a c\u1EEDa h\xE0ng Shopee`,
    blibliCategoryAttribute: `Thu\u1ED9c t\xEDnh danh m\u1EE5c c\u1EEDa h\xE0ng Blibli`,
    category: `Danh m\u1EE5c`,
    shippingSettings: `C\xE0i \u0111\u1EB7t v\u1EADn chuy\u1EC3n`,
    massEditProductDescription: `Ch\u1EC9nh s\u1EEDa mi\xEAu t\u1EA3 s\u1EA3n ph\u1EA9m h\xE0ng lo\u1EA1t`,
    iNeed: `T\xF4i c\u1EA7n`,
    workingHours: `Gi\u1EDD l\xE0m vi\u1EC7c`,
    applyToAllProducts: `\xC1p d\u1EE5ng cho t\u1EA5t c\u1EA3 s\u1EA3n ph\u1EA9m`,
    theValueJustEnteredWantIt: `Gi\xE1 tr\u1ECB v\u1EEBa nh\u1EADp v\xE0o, c\xF3 \xE1p d\u1EE5ng cho t\u1EA5t c\u1EA3 s\u1EA3n ph\u1EA9m c\u1EE7a c\xF9ng m\u1ED9t danh m\u1EE5c hay kh\xF4ng?`,
    masterProductVariantType2: `Li\xEAn k\u1EBFt thu\u1ED9c t\xEDnh c\u1EE7a S\u1EA3n ph\u1EA9m ch\xEDnh v\u1EDBi c\u1EEDa h\xE0ng b\u1EA1n mu\u1ED1n thao t\xE1c.`,
    masterProductVariantType: `Lo\u1EA1i Thu\u1ED9c t\xEDnh c\u1EE7a s\u1EA3n ph\u1EA9m ch\xEDnh`,
    matchVariantType: `Lo\u1EA1i Thu\u1ED9c t\xEDnh ph\xF9 h\u1EE3p v\u1EDBi`,
    matchTokopediaVariantType: `Lo\u1EA1i Thu\u1ED9c t\xEDnh ph\xF9 h\u1EE3p v\u1EDBi Tokopedia`,
    massEditOfShopeesCategoryAttribute: `Ch\u1EC9nh s\u1EEDa h\xE0ng lo\u1EA1t Thu\u1ED9c t\xEDnh danh m\u1EE5c c\u1EE7a c\u1EEDa h\xE0ng Shopee`,
    publishingToChannelStores: `\u0110ang \u0111\u0103ng h\xE0ng lo\u1EA1t l\xEAn c\u1EEDa h\xE0ng tr\xEAn k\xEAnh`,
    productsWereSuccessfullyPublished: `\u0110\xE3 \u0111\u0103ng 29 s\u1EA3n ph\u1EA9m`,
    allPublished: `\u0110\u0103ng th\xE0nh c\xF4ng t\u1EA5t c\u1EA3`,
    somePublishFailed: `\u0110\u0103ng th\u1EA5t b\u1EA1i m\u1ED9t ph\u1EA7n`,
    allPublishFailed: `\u0110\u0103ng th\u1EA5t b\u1EA1i t\u1EA5t c\u1EA3`,
    taskType: `Lo\u1EA1i nhi\u1EC7m v\u1EE5`,
    search: `T\xECm ki\u1EBFm`,
    creator: `Ng\u01B0\u1EDDi t\u1EA1o`,
    content: `N\u1ED9i dung`,
    publishedStoreStoreStore: `C\u1EEDa h\xE0ng \u0111\u0103ng: c\u1EEDa h\xE0ng 1, c\u1EEDa h\xE0ng 2`,
    taskStatus: `Tr\u1EA1ng th\xE1i nhi\u1EC7m v\u1EE5`,
    publishing: `\u0110ang \u0111\u0103ng`,
    successfulQtyAllQty: `S\u1ED1 l\u01B0\u1EE3ng th\xE0nh c\xF4ng`,
    massOperationHistory: `L\u1ECBch s\u1EED ho\u1EA1t \u0111\u1ED9ng h\xE0ng lo\u1EA1t`,
    theResultOfThePublishWill: `K\u1EBFt qu\u1EA3 \u0111\u0103ng s\u1EBD \u0111\u1ED3ng b\u1ED9 hi\u1EC3n th\u1ECB trong [S\u1EA3n ph\u1EA9m ch\xEDnh - L\u1ECBch s\u1EED ho\u1EA1t \u0111\u1ED9ng h\xE0ng lo\u1EA1t]`,
    theFileWillOnlyBeReserved: `T\u1EC7p ch\u1EC9 \u0111\u01B0\u1EE3c l\u01B0u trong 7 ng\xE0y, vui l\xF2ng k\u1ECBp th\u1EDDi ki\u1EC3m tra ho\u1EB7c t\u1EA3i v\u1EC1`,
    no: `Kh\xF4ng`,
    yes: `C\xF3`,
    orderProcessingDeadline: `Th\u1EDDi h\u1EA1n x\u1EED l\xFD \u0111\u01A1n h\xE0ng`,
    instant: `Ngay l\u1EADp t\u1EE9c`,
    regular: `\u0110\u1ECBnh k\u1EF3`,
    preorder: `\u0110\u1EB7t tr\u01B0\u1EDBc`,
    iWillShipOutWithinX: `T\xF4i s\u1EBD g\u1EEDi h\xE0ng trong v\xF2ng X gi\u1EDD l\xE0m vi\u1EC7c`,
    hoursWorking: `Gi\u1EDD l\xE0m vi\u1EC7c`,
    mustBeBetween: `B\u1EAFt bu\u1ED9c l\xE0 gi\u1EEFa 1-8`,
    iWillShipOutWithin: `T\xF4i s\u1EBD g\u1EEDi h\xE0ng trong v\xF2ng 3 ng\xE0y l\xE0m vi\u1EC7c. (kh\xF4ng bao g\u1ED3m ng\xE0y ngh\u1EC9 l\u1EC5 v\xE0 ng\xE0y ngh\u1EC9 c\u1EE7a d\u1ECBch v\u1EE5 giao h\xE0ng)`,
    workingDays: `Ng\xE0y l\xE0m vi\u1EC7c`,
    between: `Gi\u1EEFa 3-30`,
    preorder11: `\u0110\u1EB7t tr\u01B0\u1EDBc`,
    iNeedXDaysToShip: `T\xF4i c\u1EA7n X ng\xE0y m\u1EDBi c\xF3 th\u1EC3 g\u1EEDi h\xE0ng`,
    INeed: `T\xF4i c\u1EA7n`,
    toShip: `M\u1EDBi c\xF3 th\u1EC3 \u0111\u0103ng`,
    iNeedXWeeksToShip: `T\xF4i c\u1EA7n X tu\u1EA7n m\u1EDBi c\xF3 th\u1EC3 g\u1EEDi h\xE0ng`,
    iNeedXWorkingDays: `T\xF4i c\u1EA7n X ng\xE0y l\xE0m vi\u1EC7c m\u1EDBi c\xF3 th\u1EC3 g\u1EEDi h\xE0ng`,
    shipTime: `Th\u1EDDi gian x\u1EED l\xFD`,
    enterProcessTime: `Nh\u1EADp th\u1EDDi gian x\u1EED l\xFD`,
    betweenDays: `Trong 1-90 ng\xE0y`,
    day: `Ng\xE0y`,
    betweenWeeks: `Trong 1-13 tu\u1EA7n`,
    week: `Tu\u1EA7n`,
    between21: `Gi\u1EEFa 7-15`,
    iWillShipOutWithin22: `T\xF4i s\u1EBD g\u1EEDi h\xE0ng trong 2 ng\xE0y l\xE0m vi\u1EC7c. (kh\xF4ng bao g\u1ED3m ng\xE0y ngh\u1EC9 l\u1EC5 v\xE0 ng\xE0y ngh\u1EC9 c\u1EE7a d\u1ECBch v\u1EE5 giao h\xE0ng)`,
    lengthShouldBeBetween: `Chi\u1EC1u d\xE0i ph\u1EA3i t\u1EEB 1-999.999!`,
    widthShouldBeBetween: `Chi\u1EC1u r\u1ED9ng ph\u1EA3i t\u1EEB 1-999.999!`,
    heightShouldBeBetween: `Chi\u1EC1u cao ph\u1EA3i t\u1EEB 1-999.999!`,
    weightShouldBeBetween: `Tr\u1ECDng l\u01B0\u1EE3ng ph\u1EA3i t\u1EEB 1-5.000.000!`,
    editProductName: `Ch\u1EC9nh s\u1EEDa t\xEAn s\u1EA3n ph\u1EA9m`,
    addBeforeName: `Th\xEAm \u1EDF \u0111\u1EA7u t\xEAn`,
    addAfterName: `Th\xEAm \u1EDF cu\u1ED1i t\xEAn`,
    addBetweenName: `Th\xEAm \u1EDF gi\u1EEFa t\xEAn`,
    replaceWith: `Thay b\u1EB1ng`,
    confirm: `X\xE1c nh\u1EADn`,
    cancel: `H\u1EE7y`,
    editDescription: `Ch\u1EC9nh s\u1EEDa mi\xEAu t\u1EA3 s\u1EA3n ph\u1EA9m`,
    addAtTheStartOfThe: `Th\xEAm v\xE0o \u0111\u1EA7u m\xF4 t\u1EA3`,
    addAtTheEndOfThe: `Th\xEAm v\xE0o cu\u1ED1i m\xF4 t\u1EA3`,
    addBetweenTheDescription: `Th\xEAm v\xE0o gi\u1EEFa m\xF4 t\u1EA3`,
    replaceWith38: `Thay b\u1EB1ng`,
    rupiah: `Rp`,
    cny: `CNY`,
    chooseStoreLimit: `Ch\u1ECDn T\u1ED1i thi\u1EC3u 1 c\u1EEDa h\xE0ng \u0111\xEDch`,
    editDefaultPrice: `Ch\u1EC9nh s\u1EEDa gi\xE1 b\xE1n m\u1EB7c \u0111\u1ECBnh`,
    changePriceTo: `Tr\u1EF1c ti\u1EBFp s\u1EEDa gi\xE1 th\xE0nh`,
    addByAmount: `Theo s\u1ED1 ti\u1EC1n t\u0103ng l\xEAn`,
    reduceByAmount: `Theo s\u1ED1 ti\u1EC1n gi\u1EA3m xu\u1ED1ng`,
    addByPercent: `Theo t\u1EF7 l\u1EC7 % t\u0103ng l\xEAn`,
    reduceByPercent: `Theo t\u1EF7 l\u1EC7 % gi\u1EA3m xu\u1ED1ng`,
    defaultPriceError: `Gi\xE1 b\xE1n m\u1EB7c \u0111\u1ECBnh ph\u1EA3i t\u1EEB 0-1.000.000.000`,
    new: `M\u1EDBi`,
    used: `\u0110\xE3 qua s\u1EED d\u1EE5ng`,
    chooseDestinationStore: `Ch\u1ECDn c\u1EEDa h\xE0ng \u0111\xEDch`,
    selectStore: `Ch\u1ECDn c\u1EEDa h\xE0ng`,
    pleaseEnter: `Vui l\xF2ng nh\u1EADp`,
    selectCategories: `Vui l\xF2ng ch\u1ECDn danh m\u1EE5c`,
    ProductDescriptionShouldBeCharacters: `M\xF4 t\u1EA3 s\u1EA3n ph\u1EA9m ph\u1EA3i bao g\u1ED3m 1-7000 k\xFD t\u1EF1`,
    mainPhotos: `\u1EA2nh \u0111\u1EA1i di\u1EC7n`,
    variationImageInfo: `Ch\u1EC9nh s\u1EEDa h\xECnh \u1EA3nh Thu\u1ED9c t\xEDnh`,
    master: `S\u1EA3n ph\u1EA9m ch\xEDnh`,
    ProductImage: `H\xECnh \u1EA3nh s\u1EA3n ph\u1EA9m`,
    masterCategory: `Danh m\u1EE5c ch\xEDnh`,
    ProductDescription: `Mi\xEAu t\u1EA3 s\u1EA3n ph\u1EA9m`,
    variantName: `T\xEAn Thu\u1ED9c t\xEDnh`,
    variantImage: `H\xECnh \u1EA3nh Thu\u1ED9c t\xEDnh`,
    defaultPrice: `Gi\xE1 b\xE1n m\u1EB7c \u0111\u1ECBnh`,
    availableStock: `T\u1ED3n kho c\xF3 s\u1EB5n`,
    masterSku: `Master SKU`,
    packageSize: `K\xEDch th\u01B0\u1EDBc g\xF3i h\xE0ng(CM)`,
    length: `Chi\u1EC1u D\xE0i`,
    width: `Chi\u1EC1u R\u1ED9ng`,
    height: `Chi\u1EC1u Cao`,
    weight: `Tr\u1ECDng l\u01B0\u1EE3ng(g)`,
    minPurchaseQuantity: `S\u1ED1 l\u01B0\u1EE3ng mua t\u1ED1i thi\u1EC3u`,
    createTime: `Th\u1EDDi gian t\u1EA1o`,
    updateTime: `Th\u1EDDi gian c\u1EADp nh\u1EADt`,
    action: `Thao t\xE1c`,
    delete: `X\xF3a`,
    saveUpdate: `L\u01B0u c\u1EADp nh\u1EADt`,
    cancelUpdateConfirm: `B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n b\u1ECF qua l\u1EA7n c\u1EADp nh\u1EADt n\xE0y kh\xF4ng?`,
    select: `Ch\u1ECDn`,
    pleaseSelect: `Vui l\xF2ng ch\u1ECDn`,
    viewNow: `Xem ngay`,
    popupResultButton: `Xem d\u1EEF li\u1EC7u th\u1EA5t b\u1EA1i`,
    masterProductsImage: `S\u1EA3n ph\u1EA9m ch\xEDnh & h\xECnh \u1EA3nh`,
    brand: `Th\u01B0\u01A1ng hi\u1EC7u`,
    whatsInTheBox: `N\u1ED9i dung g\xF3i h\xE0ng`,
    viewMore: `Xem th\xEAm`,
    viewLess: `Thu g\u1ECDn`,
    totalNumber: `T\u1ED5ng s\u1ED1 l\u01B0\u1EE3ng`,
    successNumber: `S\u1ED1 l\u01B0\u1EE3ng th\xE0nh c\xF4ng`,
    failedNumber: `S\u1ED1 l\u01B0\u1EE3ng th\u1EA5t b\u1EA1i`,
    close: `\u0110\xF3ng`,
    downloadFailedData: `T\u1EA3i xu\u1ED1ng s\u1ED1 l\u01B0\u1EE3ng th\u1EA5t b\u1EA1i`,
    storeNameA: `T\xEAn c\u1EEDa h\xE0ng`,
    clickToEdit: `Nh\u1EA5p v\xE0o n\u1ED9i dung c\u1EE7a b\u1EA3ng, c\xF3 th\u1EC3 th\u1EF1c hi\u1EC7n thao t\xE1c ch\u1EC9nh s\u1EEDa!`,
    storeWarehouse: `C\u1EEDa h\xE0ng / Kho h\xE0ng`,
    productInfoSetting: `C\xE0i \u0111\u1EB7t th\xF4ng tin s\u1EA3n ph\u1EA9m`,
    editStatusError: `Vui l\xF2ng nh\u1EA5n n\xFAt X\xE1c nh\u1EADn tr\u01B0\u1EDBc, v\xE0 nh\u1EA5n \u0110\u0103ng l\xEAn c\u1EEDa h\xE0ng`,
    channelCategoryAttribute: `Thu\u1ED9c t\xEDnh danh m\u1EE5c c\u1EEDa h\xE0ng {channel}`,
    addAttributeValue: `Th\xEAm gi\xE1 tr\u1ECB thu\u1ED9c t\xEDnh`,
    canNotInputChineseLanguage: `Kh\xF4ng \u0111\u01B0\u1EE3c nh\u1EADp ti\u1EBFng Trung`,
    pleaseChoose: `Vui l\xF2ng ch\u1ECDn`,
    NoBrand: `OEM`
  }
};
